<template>
  <v-card>
    <v-flex xs12>
      <message :messages="messages"></message>
    </v-flex>
    <v-card-title>
      <div class="headline">Sub Member Listing</div>
      <v-spacer></v-spacer>
      <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
    </v-card-title>
    <v-data-table :headers="headers" :items="items" :search="search" :rows-per-page-items="itemsPerPage" :pagination.sync="pagination" item-key="name" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
          <span slot="activator">
            {{ props.header.text }}
          </span>
          <span>
            {{ props.header.text }}
          </span>
        </v-tooltip>
      </template>
      <template slot="items" slot-scope="props">
        <td class="text-xs-left">{{ props.item.name }}</td>
        <td class="text-xs-left">{{ props.item.nricPassport }}</td>
        <td class="text-xs-left">{{ props.item.dob }}</td>
        <td class="text-xs-left">{{ props.item.gender }}</td>
        <td class="text-xs-right">
          <table-action :rowData="props" :review="checkAccess(['memberReview'])" @review="doReview" :remove="checkAccess(['memberReview'])" @remove="doPromptRemove({name: props.item.name, seqNo: props.item.id})" v-if="!query"></table-action>
          <table-action :rowData="props" query @query="doQuery" v-else></table-action>
        </td>
      </template>
    </v-data-table>
    <v-btn color="primary" dark class="mb-2" @click="doNew" v-if="checkAccess(['memberReview']) && !query">
      Add Sub-Member
      <v-icon right>mdi-plus</v-icon>
    </v-btn>
    <confirm v-model="promptRemove" @ok="doDelete">
      Are you sure you want to delete the selected sub member?
      <div class="title">{{selectedId.text}}</div>
    </confirm>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'
import { mapGetters } from 'vuex'
export default {
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'NRIC/Passport', value: 'nricPassport' },
        { text: 'Date of Birth', value: 'dob' },
        { text: 'Gender', value: 'gender' },
        TableConst.tableActionHeader
      ],
      selectedId: {
        id: {
          usrId: this.id,
          seqNo: null
        },
        text: null
      },
      promptRemove: false,
      query: false
    }
  },
  created() {
    if (this.$route.name === 'subMemberListQuery') {
      this.query = true
    } else {
      this.query = false
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    async fetchData() {
      const apiURI = this.menu.subMembersList
      if (apiURI) {
        this.loading = true
        try {
          const expand = {
            usrId: this.id
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(subMember => {
              const convertList = {
                id: subMember.seq,
                name: subMember.name,
                nricPassport: subMember.nricPassport,
                dob: subMember.dob,
                gender: this.formatGender(subMember.gender)
              }
              this.items.push(convertList)
            })
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
        this.loading = false
      }
    },
    doNew() {
      const commitData = {
        tabMenu: 1,
        displayReviewTab: true
      }
      this.$store.commit('TABMENU', commitData)
      this.$router.push({ name: 'subMemberDet', params: { seq: 'new' } })
    },
    doReview(data) {
      if (data && data.item) {
        const commitData = {
          tabMenu: 1,
          displayReviewTab: true
        }
        this.$store.commit('TABMENU', commitData)
        this.$router.push({ name: 'subMemberDet', params: { seq: data.item.id } })
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.selectedId.id.seqNo = data.seqNo
        this.selectedId.text = data.name
        this.promptRemove = true
      }
    },
    doDelete() {
      const apiURI = this.menu.subMemberDelete
      if (apiURI) {
        const expand = this.selectedId.id
        this.$http.delete(expandURI(apiURI, expand)).then(result => {
          const data = result.data
          this.notify(data)
          this.fetchData()
        }).catch(err => {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
        })
      }
    },
    doQuery(data) {
      if (data && data.item) {
        const commitData = {
          tabMenu: 1,
          displayReviewTab: true
        }
        this.$store.commit('TABMENU', commitData)
        this.$router.push({ name: 'subMemberDetQuery', params: { seq: data.item.id } })
      }
    },
    formatGender(gender) {
      if (gender === 'M') {
        return 'Male'
      }
      if (gender === 'F') {
        return 'Female'
      }
    }
  },
  computed: {
    ...mapGetters([
      'checkAccess'
    ]),
    menu() {
      return this.$store.state.adminMember.menu
    }
  },
  props: ['id'],
  mixins: [
    TableConst.default,
    MessageMixin
  ]
}
</script>

<style>
</style>
